import { createContext, useCallback, useContext, useState } from 'react';

export enum OverlayIds {
  ADD_NEW_CARD = 'ADD_NEW_CARD',
  DELETE_CARD = 'DELETE_CARD',
  DELETE_ALL_CARDS = 'DELETE_ALL_CARDS',
  BANCONTACT_MOBILE_AUTH = 'BANCONTACT_MOBILE_AUTH',
}

interface Props {
  hideOverlay: (id: OverlayIds) => void;
  showOverlay: (id: OverlayIds) => void;
  checkIsActive: (id: OverlayIds) => boolean;
}

export const OverlaysContext = createContext<Props>({
  hideOverlay: () => null,
  showOverlay: () => null,
  checkIsActive: () => false,
});

type Overlays = {
  [k in OverlayIds]?: { isActive: boolean };
};

const OverlaysProvider: React.FC = ({ children }) => {
  const [overlays, setOverlays] = useState<Overlays>({});

  const hideOverlay = useCallback((id: OverlayIds) => {
    setOverlays((previousOverlays) => ({ ...previousOverlays, [id]: { isActive: false } }));
  }, []);
  const showOverlay = useCallback((id: OverlayIds) => {
    setOverlays((previousOverlays) => ({ ...previousOverlays, [id]: { isActive: true } }));
  }, []);
  const checkIsActive = useCallback(
    (id: OverlayIds) => {
      return !!overlays[id]?.isActive;
    },
    [overlays],
  );

  return (
    <OverlaysContext.Provider
      value={{
        hideOverlay,
        showOverlay,
        checkIsActive,
      }}>
      {children}
    </OverlaysContext.Provider>
  );
};

export const useOverlays = () => {
  return useContext(OverlaysContext);
};

export default OverlaysProvider;
